import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the OOG permit-approval gate.
 *
 * V1 gated the "Approve without Permit" checkboxes (Over Size + Over Weight)
 * on a field ACL over oversizeapprovedby/overweightapprovedby
 * (lib/main.pl:17312, 17337 — getACL(... 'oogapproval' ...)). We reproduce
 * that as its own component permission, separate from the general order
 * edit gates, mirroring the hazmat-approval split (useCanApproveHazmat.ts).
 */
export const OOG_APPROVAL_COMPONENT_ID = 'oog-approval';

/**
 * Whether the current user may (un)approve an OOG permit requirement without
 * a permit number on file.
 *
 * Resolved from the admin-configured component permission crossed with the
 * user's Azure AD groups. Ships **defaultDisabled**: until an admin grants a
 * group edit access on `oog-approval`, both checkboxes stay disabled for
 * everyone. Server-side enforced too (save_order_details gates an
 * oversizeapprovedby/overweightapprovedby change on the same component —
 * see _is_oog_approval_change in orders.py).
 */
export const useCanApproveOogPermit = (): boolean =>
  useResolvedAccessLevel(OOG_APPROVAL_COMPONENT_ID, false, true) >= 2;
